// Store
import store from "@/store";

export interface AppAdministratorResourcesSupplementsListFormCreate {
  organization_id: string;
  content: {
    name: string;
    description: string;
  };
}

export class AppAdministratorResourcesSupplementsListFormCreate implements AppAdministratorResourcesSupplementsListFormCreate {
  organization_id: string;
  content: {
    name: string;
    description: string;
  };

  constructor() {
    this.organization_id = store.getters.getOrganizationMember.organization_id ?? "";
    this.content = {
      name: "",
      description: "",
    };
  }
}